import { connect } from 'react-redux';
import CertifiedAccreditationsList from "./CertifiedAccreditationsList";
import {
    fetchGetCertifiedAccreditations,
    fetchUpdateCertifiedAccreditation,
    getCertifiedAccreditationsData,
    loadingCertifiedAccreditations
} from "../../../reducers/applicantAccreditations/certifiedAccreditations";
import { getTranslation } from "../../../reducers/common/localization";
import {
    MODAL_CERTIFIED_ACCREDITATION,
    MODAL_REMOVE_CERTIFIED_ACCREDITATION,
    showModal
} from '../../../reducers/common/activeModal';

const mapStateToProps = state => {
    return {
        data: getCertifiedAccreditationsData(state),
        loading: loadingCertifiedAccreditations(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetAccreditations: () => dispatch(fetchGetCertifiedAccreditations()),
        onOpenAccreditationDetailsModal: () => {
            dispatch(showModal({ modalKey: MODAL_CERTIFIED_ACCREDITATION }))
        },
        onChangeExpose: (id, data) => {
            dispatch(fetchUpdateCertifiedAccreditation(id, data));
        },
        onRemoveAccreditation: () => {
            dispatch(showModal({ modalKey: MODAL_REMOVE_CERTIFIED_ACCREDITATION }));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CertifiedAccreditationsList);



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/certifiedAccreditationsList/CertifiedAccreditationsList.container.js